import config from "../../config";
const baseUrl = config.baseUrl;

export  const PatientUrls = {

  PATIENT_ADD: baseUrl + "/patients",
  PATIENT_EDIT: baseUrl + "/patients",
  PATIENT_LIST: baseUrl + "/patients?role=2",
  PATIENT_DELETE: baseUrl + "/patients",
  PATIENT_GETBYID: baseUrl + "/patients",
  PATIENT_DROPDOWN: baseUrl + "/patients/dropdown",
  PATIENT_ROLLBACK: baseUrl + "/patients/rollback",
  PATIENT_DELETE_HARD: baseUrl + "/patients",
  TOTAL_AMOUNT_LIST: baseUrl + "/totalAmounts" 
  
}; 